const fulfillmentKeys = {
  all: ['fulfillment'],
  fulfillmentOptionsForMaterials: () =>
    [...fulfillmentKeys.all, 'fulfillmentOptionsForMaterials'] as const,
};

export default fulfillmentKeys;
